import request from '../utils/request';

//投保案件列表
export function insureList(limit,page,jd_type_id,zhcai_sn,doc_title,lawyer_name,signers) {
    let obj={
        'limit':limit,
        'page':page,
        'jd_type_id':jd_type_id,
        'zhcai_sn':zhcai_sn,
        'doc_title':doc_title,
        'lawyer_name':lawyer_name,
        'signers':signers,
    }
    return request.post('/api/toubao_case_list',obj)
}
//获取投保状态
export function insureState() {
    return request({
        url:'/api/get_toubao_status_list',
        method:'post',
    })
}
//仲裁案件转入投保案件
export function transferInsure(data) {
    return request({
        url:'/api/zhcai_case_to_toubao',
        method:'post',
        data
    })
}
//撤销投保案件
export function cancelInsure(data) {
    return request({
        url:'/api/toubao_case_chexiao',
        method:'post',
        data
    })
}
//保存财产保全申请书等需要签署的文书
export function saveSignFile(data) {
    return request({
        url:'/api/save_baquan_dizhi_wenshu',
        method:'post',
        data
    })
}
//查看上传的文件详情
export function fileDetails(data) {
    return request({
        url:'/api/zhcai_bqsdxsfy_cailiao_detail',
        method:'post',
        data
    })
}
//保存线索材料和保全法院的信息
export function saveClueMaterial(data) {
    return request({
        url:'/api/save_cailiao_fayuan_files',
        method:'post',
        data
    })
}
//批量发起签署财产保全申请书
export function signFinancialInsurance(data) {
    return request({
        url:'/api/zhcai_sign_baquan_wenshu',
        method:'post',
        data
    })
}
//批量发起签署送达地址确认书
export function letter_of_service(data) {
    return request({
        url:'/api/zhcai_sign_dizhi_wenshu',
        method:'post',
        data
    })
}
//批量发起签署网络查控申请书
export function check_and_control(data) {
    return request({
        url:'/api/zhcai_sign_chakong_wenshu',
        method:'post',
        data
    })
}
//批量提交至保险端
export function submit_to(data) {
    return request({
        url:'/api/zhcai_batch_submit_baoxian',
        method:'post',
        data
    })
}
//查看留言
export function leaveMessageList(case_id,limit,page) {
    return request.post('/api/scan_liuyan_list',{"case_id":case_id,"limit":limit,"page":page})
}
//查看待确认保单保函
export function insurancePolicyDetail(data) {
    return request({
        url:'/api/zhcai_scan_daiqueren_files',
        method:'post',
        data
    })
}
//确认保单保函是否有误
export function confirmationPolicy(case_id,check_type,bohui_liyou) {
    return request.post('/api/toubao_daiqueren_tg_bhui',{"case_id":case_id,"check_type":check_type,"bohui_liyou":bohui_liyou})
}
//再次提交投保材料到保险端
export function resubmitMaterial(data) {
    return request({
        url:'/api/zaici_tijiao_toubao_cailiao',
        method:'post',
        data
    })
}
//查看投保单
export function viewInsureList(data) {
    return request({
        url:'/api/zhcai_scan_toubaodan_files',
        method:'post',
        data
    })
}
//查看上传的已盖章投保单
export function viewsealedInsure(data) {
    return request({
        url:'/api/zhcai_toubaodan_detail',
        method:'post',
        data
    })
}
//保存上传已盖章的投保单
export function saveSealedInsure(data) {
    return request({
        url:'/api/save_toubaodan_files',
        method:'post',
        data
    })
}
//确认已上传盖过章的投保单
export function confirmUploadInsure(data) {
    return request({
        url:'/api/queren_toubaodan_files',
        method:'post',
        data
    })
}
//未读消息数量
export function unreadNum() {
     return request({
         url:'/api/get_weidu_msg_num',
         method:'post'
     })
}
//保险消息列表
export function insuranceMessageList(limit,page) {
    return request.post('/api/zhannei_msg_list',{"limit":limit,"page":page})
}
//确认消息已读
export function confirmationMessage(data) {
    return request({
        url:'/api/zhannei_msg_queren_yidu',
        method:'post',
        data
    })
}
//查看保险收费信息
export function chargeInformation(data) {
    return request({
        url:'/api/zhcai_scan_shoukuan_files',
        method:'post',
        data
    })
}
//查看上传的缴费信息
export function viewPaymentInformation(data) {
    return request({
        url:'/api/zhcai_jiaofei_detail',
        method:'post',
        data
    })
}
//保存缴费信息
export function savePaymentInformation(data) {
    return request({
        url:'/api/save_jiaofei_files',
        method:'post',
        data
    })
}
//确认完成缴费信息上传
export function completePayment(data) {
    return request({
        url:'/api/queren_jiaofei_files',
        method:'post',
        data
    })
}
//查看全部投保材料和文书
export function viewAllMaterials(data) {
    return request({
        url:'/api/scan_all_toubao_files',
        method:'post',
        data
    })
}
//下载全部保险材料
export function downloadInsure(data) {
    return request({
        url:'/api/zip_all_toubao_files',
        method:'post',
        data
    })
}
